const margin = {
  // 用户保证金列表
  userMarginList: `/chargeApi/margin/userMarginList`,
  // 时间规则状态配置
  timeStatusRuleConf: `/chargeApi/margin/timeStatusRuleConf`,
  // 保证金支付宝扫码支付
  qrcode: `/chargeApi/pay/margin/aliPay/qrcode`,
  // 保证金支付状态校验
  check: `/chargeApi/pay/margin/order/check`,
  // 删除保证金
  userMarginDel: `/chargeApi/margin/userMarginDel`,
  // 盒币购买保证金
  buyMargin: `/chargeApi/margin/buyMargin`,
  // 是否可申请退保证金
  isCanApplyMarginBack: `/chargeApi/margin/isCanApplyMarginBack`,
  // 退回保证金接口
  userMarginBack: `/chargeApi/margin/userMarginBack`,
  // 撤销退回保证金
  userMarginBackCancel: `/chargeApi/margin/userMarginBackCancel`,
  // 保证金还价
  marginBargain: `/chargeApi/margin/marginBargain`
};

export default margin;
